import { makeStyles } from "@material-ui/core";
import Focus3LineIcon from "remixicon-react/Focus3LineIcon";
import clsx from "clsx";
import { iconSize } from "../../config";

const useStyles = makeStyles((theme) => ({
  container: {
    flexShrink: 0,
    position: "relative",
    width: "100%",
    height: "100%",
    maxHeight: "60px",
    background: "white",
    borderRadius: "7px",
    overflow: "hidden",
    border: "1px solid var(--borderColor, #dfe0e0)",
    display: "inline-flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "22px",
    color: "#242423",
    boxSizing: "border-box",
    "&:hover": {
      color: "var(--primaryColor, #1A9FFF)",
      borderColor: "var(--primaryColor, #1A9FFF)",
      borderStyle: "solid",
      cursor: "pointer",
    },
    "&:hover $closeComponentContainer": {
      display: "inline",
    },

    "&:hover $nextComponentContainer": {
      opacity: 1,
      transform: "translate(0, 0)",
      transition: "transform 80ms, opacity 80ms",
    },
  },
  disabled: {
    pointerEvents: "none",
    "& $imageContainer": {
      opacity: 0.3,
    },
    "& $textContainer": {
      color: "var(--borderColor, #dfe0e0)",
    },
  },
  mainContent: {
    flex: "1 1 0",
    height: "60px",
    borderRadius: "7px",
    overflow: "hidden",
    border: "2px solid white",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    boxSizing: "border-box",
  },
  imageContainer: {
    background:
      "linear-gradient(      rgba(255, 255, 255, 0.6),       rgba(255, 255, 255, 0.6)    ), url(checkerboard_pattern.png)",
    backgroundSize: "10.5%",
    backgroundRepeat: "repeat",
    width: "60px",
    height: "60px",
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
  },
  textContainer: {
    flex: "1 1 0",
    height: "18px",
    paddingLeft: "20px",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "5px",
    display: "flex",
  },
  mainText: {
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: 400,
    lineHeight: "18px",
    wordWrap: "break-word",
  },
  secondaryText: {
    color: "#DFE0E0",
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: 400,
    lineHeight: "18px",
    wordWrap: "break-word",
  },
  closeComponentContainer: {
    position: "absolute",
    top: "4px",
    right: "4px",
    display: "none",
  },
  nextComponentContainer: {
    position: "absolute",
    top: "50%",
    right: "8px",
    opacity: 0,
    transform: "translate(-20px,0)",
    // transition: "transform 1s, opacity 1s",
  },
  centered: {
    justifyContent: "center",
  },
  dashed: {
    borderStyle: "dashed ",
  },
  visible: {
    display: "inline",
  },
}));

export const HotspotListItemPure = ({
  thumbnail: Thumbnail,
  thumbnailProps,
  disabled,
  centered,
  dashed,
  text,
  secondaryText,
  children,
  closeComponent: CloseComponent,
  nextComponent: NextComponent,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <div
      className={clsx(
        classes.container,
        disabled && classes.disabled,
        dashed && classes.dashed
      )}
      {...rest}
    >
      <div className={clsx(classes.mainContent, centered && classes.centered)}>
        {children ? (
          children
        ) : (
          <>
            {Thumbnail ? (
              <div className={classes.imageContainer}>
                {Thumbnail === "placeholder" ? (
                  <Focus3LineIcon size={iconSize} />
                ) : (
                  <Thumbnail {...thumbnailProps} />
                )}
              </div>
            ) : null}
            <div className={classes.textContainer}>
              <div className={classes.mainText}>
                {text || "Placeholder text"}
              </div>
              {secondaryText ? (
                <div className={classes.secondaryText}>{secondaryText}</div>
              ) : null}
            </div>
          </>
        )}
        <div className={clsx(classes.closeComponentContainer)}>
          {CloseComponent}
        </div>
        <div className={clsx(classes.nextComponentContainer)}>
          {NextComponent}
        </div>
      </div>
    </div>
  );
};

export default HotspotListItemPure;
